import React, { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import "./NavbarComponents.css";
import { useNavbarCategories } from "../Context/NavbarCategoriesContext";

const NavbarWithDropdown = ({ isHomePage }) => {
  const { categories } = useNavbarCategories();
  const [activeMenu, setActiveMenu] = useState(null);
  const [subMenu, setSubMenu] = useState(null);
  const dropdownRef = useRef(null);

  const handleMenuClick = (category) => {
    setActiveMenu(activeMenu === category ? null : category);
    setSubMenu(null); // Reset submenu when clicking main menu
  };

  const handleSubMenuClick = (subcategory) => {
    setSubMenu(subMenu === subcategory ? null : subcategory);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setActiveMenu(null);
        setSubMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="navbar-container" ref={dropdownRef}>
      <ul className="nav">
        {categories.map((category) => (
          <li
            key={category.name}
            className="nav-item position-relative d-flex align-items-center"
          >
            {/* Main Category Link */}
            <button
              className="link-style-custom-design border-0"
              style={{
                color:
                  activeMenu === category.name ? "rgb(0, 113, 61)" : "#111111",
                backgroundColor:
                  activeMenu === category.name
                    ? "rgba(0, 113, 61, 0.1)"
                    : "transparent",
                borderRadius: "5px",
                padding: "5px 10px",
              }}
              onClick={() => handleMenuClick(category.name)}
            >
              {category.name}
            </button>

            {/* Dropdown Menu */}
            {activeMenu === category.name && (
              <div className="dropdown-menu-custom rounded-3">
                {category.children.map((subCategory) => (
                  <React.Fragment key={subCategory.name}>
                    {subCategory.children && subCategory.children.length > 0 ? (
                      // If subcategory has children, show expandable menu with arrow icon
                      <button
                        className="dropdown-item rounded-3 py-2 px-3 d-flex justify-content-between align-items-center"
                        onClick={() => handleSubMenuClick(subCategory.name)}
                      >
                        {subCategory.name}
                        <FontAwesomeIcon icon={faArrowRight} />
                      </button>
                    ) : (
                      // If no subcategories, show as a link without arrow icon
                      <NavLink
                        to={`/products/category/${subCategory.name}`}
                        className="dropdown-item rounded-3 py-2 px-3"
                        style={({ isActive }) => ({
                          color: isActive ? "#00713D" : "#111111",
                          backgroundColor: isActive
                            ? "#00713D1A"
                            : "transparent",
                          borderRadius: "5px",
                          padding: "5px 10px",
                        })}
                        onClick={() => {
                          setActiveMenu(null);
                          setSubMenu(null);
                        }}
                      >
                        {subCategory.name}
                      </NavLink>
                    )}

                    {/* Submenu (Only appears for selected subcategory) */}
                    {subMenu === subCategory.name &&
                      subCategory.children?.length > 0 && (
                        <div className="submenu rounded-3">
                          {subCategory.children.map((child) => (
                            <NavLink
                              key={child.name}
                              to={`/products/category/${child.name}`}
                              className="dropdown-item rounded-3 py-2 px-3"
                              style={({ isActive }) => ({
                                color: isActive ? "#00713D" : "#111111",
                                backgroundColor: isActive
                                  ? "#00713D1A"
                                  : "transparent",
                                borderRadius: "5px",
                                padding: "5px 10px",
                              })}
                              onClick={() => {
                                setActiveMenu(null);
                                setSubMenu(null);
                              }}
                            >
                              {child.name}
                            </NavLink>
                          ))}
                        </div>
                      )}
                  </React.Fragment>
                ))}
              </div>
            )}
          </li>
        ))}

        {/* Additional Links with proper spacing */}
        <li className="nav-item position-relative d-flex align-items-center">
          <NavLink
            className="link-style-custom-design mx-0"
            to="/about-us"
            style={({ isActive }) => ({
              color: isActive ? "#00713D" : "#111111",
              backgroundColor: isActive ? "#00713D1A" : "transparent",
              borderRadius: "5px",
              padding: "5px 10px",
              margin: "0 10px",
            })}
          >
            About Us
          </NavLink>
        </li>
        <li className="nav-item position-relative d-flex align-items-center">
          <NavLink
            className="link-style-custom-design mx-0"
            to="/contact-us"
            style={({ isActive }) => ({
              color: isActive ? "#00713D" : "#111111",
              backgroundColor: isActive ? "#00713D1A" : "transparent",
              borderRadius: "5px",
              padding: "5px 10px",
              margin: "0 10px",
            })}
          >
            Contact Us
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default NavbarWithDropdown;
